export const routeName = 'ReclamationCreatePage'

export const route = {
  path: '/reclamation/create',
  name: routeName,
  component: () => import('./ReclamationCreatePage.vue')
}
